import { Component, Input } from '@angular/core';
import { PagamentoListagemDto } from '@usucampeao/lib-reurb-simplificado';

@Component({
  selector: 'usucampeao-tabela-pagamentos',
  templateUrl: './tabela-pagamentos.component.html',
  styleUrls: ['./tabela-pagamentos.component.scss']
})
export class TabelaPagamentosComponent {
  @Input() pagamentos: PagamentoListagemDto[] = [];
  @Input() valorServico: number;
  @Input() valorDesconto: number;

  public get pagamentoAVista(): boolean {
    return this.pagamentos?.length === 1;
  }

  public textoPrimeiraParcela(parcela: PagamentoListagemDto): string {
    if (this.pagamentoAVista) {
      return 'Parcela única';
    }

    const possuiMaisDeUmaEntrada = this.pagamentos.filter(pagamento => pagamento.parcela === 0).length > 1;
    if (possuiMaisDeUmaEntrada) {
      return `Entrada ${parcela.subparcela}`;
    }

    return 'Entrada';
  }
}
